module.exports = __webpack_public_path__ + "media/images/arrow_blue_left-825fb16c3a5454f835efd86b7d113bd2.svg";